import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

const ratingsAPI = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getRatings: build.query<any, any>({
      queryFn: async () => {
        let { data } = await supabase.from("categories").select("*");
        return { data };
      },
      providesTags: ["appointees"],
    }),
    updateRatings: build.mutation<any, any>({
      queryFn: async (rating: any) => {
        let { data } = await supabase
          .from("categories")
          .update(rating)
          .eq("id", rating.id)
          .select();
        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
  }),
  overrideExisting: true,
});

export const { useGetRatingsQuery, useUpdateRatingsMutation } = ratingsAPI;
